import { render } from "./stock.vue?vue&type=template&id=4c22abe6"
import script from "./stock.vue?vue&type=script&lang=ts"
export * from "./stock.vue?vue&type=script&lang=ts"
script.render = render

export default script